import { useState } from "react";
import { Plus } from "lucide-react";
import { Button } from "@/components/ui/button";
import { api } from "@/lib/api";
import { Panel, Table, Pill, useLoad, FormDialog, act } from "@/components/common";

export function CompaniesAdmin() {
  const { data, reload } = useLoad(() => api.get("/companies?include_retired=true").then((r) => r.data));
  const [edit, setEdit] = useState(null);
  const save = async (v) => {
    if (edit.id) await api.put(`/companies/${edit.id}`, { name: v.name, active: edit.active });
    else await api.post("/companies", { name: v.name });
    reload();
  };
  const toggle = (c) => act(api.put(`/companies/${c.id}`, { name: c.name, active: !c.active }), c.active ? "Company retired" : "Company restored").then(reload);
  return (
    <Panel title="Companies" testid="companies-panel" action={<Button size="sm" data-testid="add-company-btn" onClick={() => setEdit({})}><Plus className="mr-1 h-4 w-4" />Add company</Button>}>
      <p className="mb-3 text-xs text-slate-500">Each project belongs to one or more of these companies. Retired companies stay on existing projects but can't be picked for new ones.</p>
      <Table rows={data || []} cols={[{ k: "name", h: "Company" }, { k: "projects", h: "Projects" },
        { k: "active", h: "Status", r: (c) => <Pill tone={c.active ? "green" : "slate"}>{c.active ? "active" : "retired"}</Pill> },
        { k: "x", h: "", r: (c) => <div className="flex gap-1">
          <Button size="sm" variant="ghost" className="h-7 text-xs" data-testid={`rename-company-${c.id}`} onClick={() => setEdit(c)}>Rename</Button>
          <Button size="sm" variant="ghost" className="h-7 text-xs" data-testid={`toggle-company-${c.id}`} onClick={() => toggle(c)}>{c.active ? "Retire" : "Restore"}</Button></div> }]} />
      <FormDialog open={!!edit} onOpenChange={(o) => !o && setEdit(null)} title={edit?.id ? "Rename company" : "Add company"} testid="company-form" initial={{ name: edit?.name || "" }}
        fields={[{ name: "name", label: "Company name", required: true }]} onSubmit={save} />
    </Panel>
  );
}
